// Components/Header.js — Solponiente
import React from "react";

const Header = () => {
  return (
    <header className="border-bottom mb-4" style={{ backgroundColor: "#ffffff" }}>
      <nav className="navbar navbar-expand navbar-light px-3">
        <div className="navbar-brand d-flex align-items-center">
          <span className="fw-bold text-primary">SOLPONIENTE</span>
          <span className="text-muted ms-2">Área de Gestión</span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
